import { isValidTechSourceObject } from './isValidTechSourceObject';

// the valid sources are: string | Tech.SourceObject | Tech.SourceObject[]
export function isValidSources(sources?: unknown): boolean {
  if (typeof sources === 'string') {
    return true;
  }

  if (Array.isArray(sources) && sources.length > 0) {
    return sources.every(sourceItem => {
      return isValidTechSourceObject(sourceItem);
    });
  }

  if (isValidTechSourceObject(sources)) {
    return true;
  }

  // if()
  return false;
}
